import React from 'react';
import { Box } from '@mui/material';

const ResizeHandle = ({ onMouseDown, isResizing }) => {
  return (
    <Box
      onMouseDown={onMouseDown}
      sx={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: '4px',
        cursor: 'ew-resize',
        backgroundColor: isResizing ? 'primary.main' : 'transparent',
        '&:hover': {
          backgroundColor: 'primary.main',
          opacity: 0.3,
        },
        zIndex: 1000,
      }}
    />
  );
};

export default ResizeHandle;